import { Button, IconButton, Stack, Typography } from '@healthinal/ui';
import { TypographyLink } from '../../../components/TypographyLink.tsx';
import { Delete } from '@mui/icons-material';
import { ReferencePersonDto } from '../../../api/generated/model/bezugspersonDto.ts';



export function ReferencePersonDisplay({
    person,
}: {
    person: ReferencePersonDto;
}) {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
            <Stack>
                <Typography level="title-sm">
                    {person.firstName} {person.lastName}
                    {person.position && ` (${person.position})`}
                </Typography>

                <TypographyLink href={`mailto:${person.email ?? ''}`} level="body-sm">
                    {person.email}
                </TypographyLink>

                <TypographyLink href={`tel:${person.phoneNumber ?? ''}`} level="body-sm">
                    {person.phoneNumber}
                </TypographyLink>
            </Stack>
        </Stack>
    );
}